// import React, { useEffect, useRef } from "react";

// const LineChart = ({ data, index }) => {
//   const canvasRef = useRef(null);
//   const chartRef = useRef(null); // To store the chart instance
  
//   //data 
//   const DATA_COUNT = 2030;
// const labels = [];
// for (let i = 2025; i <= DATA_COUNT; ++i) {
//   labels.push(i.toString());
// }
// const datapoints = [0, 20, 40, 60, 40];
// const data = {
//   labels: labels,
//   datasets: [
//     {
//       label: 'Total Plans: ',
//       data: datapoints,
//       borderColor: 'rgba(0, 182, 155, 1)',
//       fill: false,
//       cubicInterpolationMode: 'monotone',
//       tension: 0.4
//     }
//   ]
// };
// //config
// const config = {
//     type: "line",
//     data: data,
//     options: {
//       responsive: true,
//       plugins: {
//         title: {
//           display: true,
//           text: `#${index + 1} - ${data.name} (Total Plans: ${data.total_plans})`,
//           align: "start", // Left-aligns the title
//           font: {
//             size: 16, // Adjust size if needed
//             weight: "bold",
//           },
//           padding: {
//             bottom: 10, // Adds space below the title
//           },
//         },
//       },
//       interaction: {
//         intersect: false,
//       },
//       scales: {
//         x: {
//           display: true,
//           title: {
//             display: false,
//           },
//           grid: {
//             display: false, // Hides vertical grid lines
//           },
//         },
//         y: {
//           display: true,
//           title: {
//             display: false,
//           },
//           suggestedMin: 0,
//           suggestedMax: 100,
//           ticks: {
//             stepSize: 25, // Only show 0, 25, 50, 75, 100
//           },
//           grid: {
//             drawTicks: true,
//             drawBorder: true,
//           },
//         },
//       },
//     },
//   };
//   useEffect(() => {
//     const ctx = canvasRef.current.getContext("2d");

//     // Destroy the previous chart instance if it exists
//     if (chartRef.current) {
//       chartRef.current.destroy();
//     }

//     // Create a new chart instance and store it in the ref
//     chartRef.current = new Chart(ctx,config);

//     // Cleanup function to destroy the chart when the component unmounts
//     return () => {
//       if (chartRef.current) {
//         chartRef.current.destroy();
//       }
//     };
//   }, []); // Empty dependency array ensures this runs only once

//   return <canvas ref={canvasRef} width={280} height={280}></canvas>;
// };

// export default LineChart;

import React, { useEffect, useRef } from "react";
const LineChart = ({ data, index }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null); 

  useEffect(() => {
    const ctx = canvasRef.current.getContext("2d");

    // Destroy previous chart instance if it exists
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    // Convert year and plans data into chart format
    const labels = Object.keys(data.plans_by_month);
    const datapoints = Object.values(data.plans_by_month);

    const chartData = {
      labels: labels,
      datasets: [
        {
          label: "Total Plans",
          data: datapoints,
          borderColor: "rgba(0, 182, 155, 1)",
          backgroundColor: "rgba(0, 182, 155, 0.1)",
          fill: true,
          cubicInterpolationMode: "monotone",
          tension: 0.4
        }
      ]
    };

    const config = {
      type: "line",
      data: chartData,
      options: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: `#${index + 1} - ${data.name} (Total Plans: ${data.total_plans})`,
            align: "start",
            font: { size: 16, weight: "bold" },
            padding: { bottom: 10 }
          }
        },
        interaction: { intersect: false },
        scales: {
          x: {
            display: true,
            title: { display: true, text: "Months" },
            grid: { display: false }
          },
          y: {
            display: true,
            title: { display: true, text: "Plans" },
            suggestedMin: 0,
            ticks: { stepSize: 1 },
            grid: { drawTicks: true, drawBorder: true }
          }
        }
      }
    };

    chartRef.current = new Chart(ctx, config);

    // Cleanup
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [data, index]);

  return <canvas ref={canvasRef} width={250} height={280}></canvas>;
};

export default LineChart;
